import { render, staticRenderFns } from "./FmPoperDemo.vue?vue&type=template&id=39703de2&scoped=true&"
import script from "./FmPoperDemo.vue?vue&type=script&lang=js&"
export * from "./FmPoperDemo.vue?vue&type=script&lang=js&"
import style0 from "./FmPoperDemo.vue?vue&type=style&index=0&id=39703de2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39703de2",
  null
  
)

export default component.exports